/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateBeamQualityDoseRateValueListDto } from './CreateBeamQualityDoseRateValueListDto';
import {
    CreateBeamQualityDoseRateValueListDtoFromJSON,
    CreateBeamQualityDoseRateValueListDtoFromJSONTyped,
    CreateBeamQualityDoseRateValueListDtoToJSON,
} from './CreateBeamQualityDoseRateValueListDto';

/**
 * 
 * @export
 * @interface CreateBeamQualityParameterContainerDto
 */
export interface CreateBeamQualityParameterContainerDto {
    /**
     * 
     * @type {Array<CreateBeamQualityDoseRateValueListDto>}
     * @memberof CreateBeamQualityParameterContainerDto
     */
    beamQualitiesElectron: Array<CreateBeamQualityDoseRateValueListDto>;
    /**
     * 
     * @type {Array<CreateBeamQualityDoseRateValueListDto>}
     * @memberof CreateBeamQualityParameterContainerDto
     */
    beamQualitiesPhoton: Array<CreateBeamQualityDoseRateValueListDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBeamQualityParameterContainerDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBeamQualityParameterContainerDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateBeamQualityParameterContainerDto
     */
    $type?: CreateBeamQualityParameterContainerDtoTypeEnum;
}


/**
 * @export
 */
export const CreateBeamQualityParameterContainerDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamQualityParameterContainerDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamQualityParameterContainerDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateBeamQualityParameterContainerDtoTypeEnum = typeof CreateBeamQualityParameterContainerDtoTypeEnum[keyof typeof CreateBeamQualityParameterContainerDtoTypeEnum];



/**
 * Check if a given object implements the CreateBeamQualityParameterContainerDto interface.
 */
export function instanceOfCreateBeamQualityParameterContainerDto(value?: unknown): value is CreateBeamQualityParameterContainerDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateBeamQualityParameterContainerDtoTypeEnum)[0];
}

export function CreateBeamQualityParameterContainerDtoFromJSON(json: any): CreateBeamQualityParameterContainerDto {
    return CreateBeamQualityParameterContainerDtoFromJSONTyped(json, false);
}

export function CreateBeamQualityParameterContainerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBeamQualityParameterContainerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'beamQualitiesElectron': ((json['beamQualitiesElectron'] as Array<any>).map(CreateBeamQualityDoseRateValueListDtoFromJSON)),
        'beamQualitiesPhoton': ((json['beamQualitiesPhoton'] as Array<any>).map(CreateBeamQualityDoseRateValueListDtoFromJSON)),
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateBeamQualityParameterContainerDtoToJSON(value?: CreateBeamQualityParameterContainerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'beamQualitiesElectron': ((value['beamQualitiesElectron'] as Array<any>).map(CreateBeamQualityDoseRateValueListDtoToJSON)),
        'beamQualitiesPhoton': ((value['beamQualitiesPhoton'] as Array<any>).map(CreateBeamQualityDoseRateValueListDtoToJSON)),
        'isRequired': value['isRequired'],
        'isEnabled': value['isEnabled'],
        '$type': value['$type'],
    });
}

